'use client'

import { X16 } from '@vinted/monochrome-icons'
import { Badge, Icon, Image } from '@vinted/web-ui'

import { getSessionStorageItem, useLocation } from '@marketplace-web/shared/browser'
import { urlWithParams } from '@marketplace-web/shared/utils'

const SearchByImageFilter = () => {
  const { search_by_image_uuid } = useLocation().searchParams

  const imageUrl = getSessionStorageItem('search_by_image_url')

  const handleRemove = () => {
    window.history.pushState(
      null,
      '',
      urlWithParams(window.location.href, {
        search_by_image_uuid: '',
      }),
    )
  }

  if (!search_by_image_uuid) return undefined

  return (
    <div className="u-position-relative u-margin-right-large u-margin-top-regular u-margin-bottom-regular">
      <Image src={imageUrl} styling={Image.Styling.Circle} size={Image.Size.Large} />

      <div className="u-position-absolute" style={{ top: '-25%', right: '-25%' }}>
        <button type="button" onClick={handleRemove}>
          <Badge icon={<Icon name={X16} />} theme="muted" styling={Badge.Styling.Light} />
        </button>
      </div>
    </div>
  )
}

export default SearchByImageFilter
